<template>
  <div class="folder-navigator">
    <div class="mt-2" v-if="showConfirmButton">
      <div class="col-12 btn-group mb-4" v-if="showConfirmButton">
        <button class="btn btn-sm btn-outline-dark col-6" @click="emitCancelChangeSavePath">
          <i class="fas fa-arrow-left"></i>
          Annuler
        </button>
        <button class="btn btn-sm btn-outline-success col-6" @click="emitSelectedPath" :disabled="isGettingRepertoires">
          <span>
            <i class="fas fa-save"></i> Modifier le chemin
          </span>
        </button>
      </div>
    </div>
    <div v-if="attachment != null">
    </div>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th class="">
            Enregistrer {{ attachment ? attachment.name : '' }} dans
            <button class="btn btn-outline-secondary btn-sm btn-force-refresh float-right" @click="getRepertoires(true)" title="Rafraichir">
              <i class="fas fa-sync"></i>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="repertoire in repertoires" :key="repertoire" v-show="!isGettingRepertoires">
          <td>
            <button
              class="btn btn-outline-secondary w-100 text-left"
              @click="updateSubfolderPath(repertoire)"
              :disabled="isGettingRepertoires"
            >
              {{ repertoire }}
            </button>
          </td>
        </tr>
        <tr v-if="isGettingRepertoires">
          <td class="text-center">
            <i class="fas fa-spin fa-spinner"></i>
          </td>
        </tr>
        <tr v-if="!isGettingRepertoires && (!repertoires || repertoires.length == 0)">
          <td class="text-center">
            <i class="fas fa-spin fa-spinner" v-if="isLoading"></i>
            <span v-if="!isLoading">Aucun résultat</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import { Attachment, FolderTreeNode } from '../interfaces/interfaces'

@Component
export default class FolderNavigator extends Vue {
  @Prop({ default: false }) showConfirmButton = false;
  @Prop({ default: '' }) initialPath!: string;
  @Prop({ required: true }) dossier!: any;
  @Prop() attachment?: Attachment;

  subfolderPath: string|null = null;
  repertoires: string[] = [];
  repertoiresHierarchy: FolderTreeNode[]|null = null;
  isLoading = false;
  isGettingRepertoires = false;

  async mounted()
  {
    if(this.attachment)
    {
      this.subfolderPath = this.attachment.savePath!;
    }
    else
    {
      this.subfolderPath = this.initialPath ?? "";
    }
    await this.getRepertoires();
  }

  async getRepertoires(forceRefresh = false)
  {
    this.isLoading = true;
    this.isGettingRepertoires = true;
    try
    {
      if(this.hasPerAttachmentSavePathCapability)
      {
        this.repertoiresHierarchy = this.$store.getters.getRepertoiresHierarchyHistoryFor(this.dossier.id);
        if(this.repertoiresHierarchy == null || forceRefresh == true)
        {
          this.repertoiresHierarchy = await (this as any).getCloudSubfoldersHierarchy(this.dossier);
          this.$store.commit('addRepertoiresHierarchy', { dossierId: this.dossier.id, repertoiresHierarchy: this.repertoiresHierarchy });
        }

        this.repertoires = this.getRepertoiresForSubfolderPath();
      }
      else
      {
        this.repertoires = await (this as any).getCloudSubfolders(this.dossier, this.subfolderPath!);
      }
    }
    catch (error)
    {
      console.error('Error fetching repertoires:', error);
      this.$store.dispatch('setErrorMessage', 'Impossible de récupérer les répertoires');
    }
    finally
    {
      this.isLoading = false;
      this.isGettingRepertoires = false;
    }
  }

  updateSubfolderPath(repertoire: string)
  {
    if (repertoire === '..')
    {
      this.subfolderPath = this.subfolderPath!.substring(0, this.subfolderPath!.lastIndexOf('/'));
    }
    else
    {
      this.subfolderPath += (this.subfolderPath ? '/' : '') + repertoire;
    }
    this.subfolderPath = this.subfolderPath!.replace(/^\/|\/$/g, '');
    this.getRepertoires();

    if(!this.showConfirmButton)
    {
      this.emitSelectedPath();
    }
  }

  @Emit('path-selected')
  emitSelectedPath()
  {
    return this.subfolderPath;
  }

  @Emit('cancel-change-save-path')
  emitCancelChangeSavePath()
  {
    return null;
  }

  get hasPerAttachmentSavePathCapability()
  {
    try
    {
      return this.$store.state.capabilities.includes('per_attachment_save_path');
    }
    catch(e)
    {
      console.error(e);
      return false;
    }
  }

  getRepertoiresForSubfolderPath(): string[]
  {
    const segments = this.subfolderPath!
      .split('/')
      .map(s => s.trim())
      .filter(s => s.length > 0);

    let currentLevel = this.repertoiresHierarchy!;

    for (const seg of segments)
    {
      const next = currentLevel.find(n => n.name === seg);
      if (!next)
      {
        return [];
      }
      currentLevel = next.children;
    }

    const names = currentLevel.map(n => n.name);

    if (segments.length > 0)
    {
      return ['..', ...names];
    }

    return names;
  }
}
</script>

<style scoped lang="scss">
.btn-force-refresh
{
  font-size: 0.7em;
}
</style>

